<div class="books-container">
  @if (isLoadingResults || isRateLimitReached) {
  <div class="books-loading-shade seccion-media">
    @if (isLoadingResults) {
    <mat-spinner></mat-spinner>
    }
    @if (isRateLimitReached) {
    <div class="books-rate-limit-reached">
      limite superado ?
    </div>
    }
  </div>
  }

  <div class="books-filters-container" *ngIf="!isLoadingResults">
    <div class="filters-title">
      <h3>Filtros</h3>
      <mat-icon class="hoverable" *ngIf="!isFilteresOpened"
        (click)="clickAbrirCerrarFiltros()">keyboard_arrow_up</mat-icon>
      <mat-icon class="hoverable" *ngIf="isFilteresOpened"
        (click)="clickAbrirCerrarFiltros()">keyboard_arrow_down</mat-icon>
    </div>
    <form *ngIf="isFilteresOpened" [formGroup]="filtrosForm" class="books-filters">
      <div class="row" *ngIf="true">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Estado</mat-label>
          <mat-select formControlName="estado">
            <mat-option [value]="'no-leido'">No Leido</mat-option>
            <mat-option [value]="'leido'">Leido</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Razon</mat-label>
          <mat-select formControlName="reason">
            <mat-option [value]="'general'">General</mat-option>
            <mat-option [value]="'purchase-problem'">Problema compra</mat-option>
            <mat-option [value]="'publicadx'">Publicadx</mat-option>
            <mat-option [value]="'feedback'">Feedback</mat-option>
            <mat-option [value]="'other'">Otro</mat-option>
            <mat-option [value]="'all'">Todos</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </form>
    <div class="row" *ngIf="true">
      <button mat-raised-button (click)="buscar()">Buscar</button>
    </div>
  </div>

  <div class="books-table-container" [hidden]="isLoadingResults">
    <mat-paginator [length]="resultsLength" [pageSize]="30" aria-label="Seleccion pagina comments"></mat-paginator>
    <table mat-table [dataSource]="data" class="books-table" matSort matSortActive="created" matSortDisableClear
      matSortDirection="desc">
      <!-- Id Column -->
      <ng-container matColumnDef="_id">
        <th mat-header-cell *matHeaderCellDef>#</th>
        <td mat-cell *matCellDef="let row">{{row._id}}</td>
      </ng-container>

      <!-- Comment Column -->
      <ng-container matColumnDef="book">
        <th mat-header-cell *matHeaderCellDef disableClear>
          Comentarios
        </th>
        <td mat-cell *matCellDef="let row">
          <!-- <app-comment-mobile [comment]="row"></app-comment-mobile> -->
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          Acciones
        </th>
        <td mat-cell *matCellDef="let row">
          <button (click)="marcarLeido(row);" *ngIf="esEstadoNoLeido(row)">leido</button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [length]="resultsLength" [pageSize]="30" aria-label="Seleccion pagina comments"></mat-paginator>

  </div>

</div>
